/**
 * Web Work Mix tab of Platform Stats — the response contract is owned by
 * @dreamai/types (api/platform-stats-web-work-mix.ts); this module re-exports
 * it and adds the UI-only constants (selector options, kind palette).
 */

import type { WebWorkKind, WebWorkSourceFilter } from '@dreamai/types';
import { WEB_WORK_KINDS } from '@dreamai/types';

export type {
  Blocker,
  BlockerCount,
  DomainCount,
  HandoffReason,
  KindCount,
  ReasonCount,
  WebWorkBlockedKindStats,
  WebWorkBlockedWeeklyBucket,
  WebWorkBlockerStats,
  WebWorkKind,
  WebWorkKindStats,
  WebWorkMixResponse,
  WebWorkMixWarmingResponse,
  WebWorkReasonStats,
  WebWorkSourceFilter,
  WebWorkWeeklyBucket,
} from '@dreamai/types';
export {
  BLOCKERS,
  BLOCKER_LABELS,
  HANDOFF_REASONS,
  HANDOFF_REASON_LABELS,
  WEB_WORK_KINDS,
  WEB_WORK_KIND_LABELS,
} from '@dreamai/types';

export const WEEK_OPTIONS = [4, 6, 8, 13] as const;
export const DEFAULT_WEEKS = 6;

export const SOURCE_OPTIONS: ReadonlyArray<{
  value: WebWorkSourceFilter;
  label: string;
}> = [
  { value: 'all', label: 'All human web work' },
  { value: 'web_action', label: 'web_action tasks' },
  { value: 'intervention', label: 'Interventions' },
];

/** One stable colour per task kind so a kind looks the same in every chart. */
const KIND_PALETTE = [
  '#1c1c1c',
  '#4b5563',
  '#2f5bd6',
  '#7c3aed',
  '#0d9488',
  '#d97706',
  '#dc2626',
  '#db2777',
  '#65a30d',
  '#0891b2',
  '#a16207',
  '#6b7280',
  '#9ca3af',
  '#c4b5fd',
  '#fca5a5',
  '#d1d5db',
];

export const KIND_COLOURS: Record<WebWorkKind, string> = Object.fromEntries(
  WEB_WORK_KINDS.map((kind, i) => [
    kind,
    KIND_PALETTE[i % KIND_PALETTE.length],
  ]),
) as Record<WebWorkKind, string>;

/** Blocker charts reuse the same palette by rank so the legend stays legible. */
export const RANK_PALETTE = KIND_PALETTE;
